/**
 * ParentLayout.tsx  -  Shell for the parent portal.
 */

import { LayoutDashboard, MessageSquare } from "lucide-react";
import { useParentUnreadCount } from "@/services/parentApi";
import { PortalShell } from "./PortalShell";

export default function ParentLayout() {
  const { data: unread = 0 } = useParentUnreadCount();
  return (
    <PortalShell
      portalLabel="Parents"
      nav={[
        { to: "/parent", icon: LayoutDashboard, label: "My children", end: true },
        { to: "/parent/messages", icon: MessageSquare, label: "Messages", count: unread },
      ]}
    />
  );
}
